// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__264R3","content":"styles_content__1pYky","checkbox":"styles_checkbox__1CyeN","checkboxLabel":"styles_checkboxLabel__23cPa"};